import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Question',
    field: 'question',
    section: '',
    ...relationField({
      validation: {required: true},
      type: 'one',
      localKey: 'questionId',
      // fk: 'id',
      namespace: 'question',
      filterIs: 'text-filter'
    }),
    component: null
  }),
  createColumn({
    label: 'Person Event',
    field: 'personEvent',
    ...relationField({
      validation: {required: true},
      type: 'one',
      localKey: 'personEventId',
      // fk: 'id',
      namespace: 'personEvent',
      filterIs: 'text-filter'
    }),
    component: null
  }),
  createColumn({
    label: 'Address',
    field: 'address',
    ...relationField({
      validation: {required: false},
      type: 'one',
      localKey: 'addressId',
      // fk: 'id',
      namespace: 'address',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Boolean Answer',
    field: 'boolAnswer',
    defaultValue: false,
    type: 'boolean',
    // component: booleanComponent
    component: null
  }),
  createColumn({
    label: 'Open Text Answer',
    field: 'openAnswer',
    // component: inputTextField({ req: false, max: 255 })
    component: null
  }),
  createColumn({
    label: 'Select Answer',
    field: 'selectAnswer',
    // component: inputTextField({ req: false, max: 255 })
    component: null
  })
].concat(defaultColumns)
